document.addEventListener('DOMContentLoaded', function() {
    // Show the first tab and hide the rest
    const tabsNav = document.querySelectorAll('#tabs-nav li');
    const tabContents = document.querySelectorAll('.tab-content');
    const tabsContainer = document.querySelector('.tabs-content');

    if (tabsNav[0]) tabsNav[0].classList.add('active');
    tabContents.forEach((content, index) => {
        if (index !== 0) {
            content.style.display = 'none';
        }
    });

    // Fetch server-rendered HTML from the alternate collection template into
    // one tab; shared by the click path and the first-tab prefetch below.
    function loadTab(content, onDone, attempt) {
        attempt = attempt || 0;
        if (content.dataset.loaded !== 'false' || content.dataset.loading) return;
        const handle = content.dataset.collectionHandle;
        if (!handle) return;
        content.dataset.loading = 'true';
        fetch(`/collections/${handle}?view=product-grid`, {credentials: 'same-origin'})
          .then(res => res.ok ? res.text() : Promise.reject(res))
          .then(html => {
            content.innerHTML = html;
            // The first tab was Liquid-rendered with `limit: pro_limit`; the
            // alternate template renders 20, so trim it back to that count.
            if (content.hasAttribute('data-wbn-trim')) {
                const limit = parseInt(content.dataset.proLimit, 10);
                if (limit > 0) {
                    Array.prototype.slice.call(content.querySelectorAll(':scope > .grid__item'), limit)
                      .forEach(node => node.remove());
                }
            }
            // Re-run theme initialise functions for injected content
            try {
              if (typeof theme !== 'undefined' && typeof theme.reinitProductGridItem === 'function') {
                theme.reinitProductGridItem(content);
              } else {
                if (typeof window.initializeVariantSelection === 'function') window.initializeVariantSelection();
                if (typeof window.updatePriceVisibility === 'function') window.updatePriceVisibility();
                if (typeof window.initializeTagDisplay === 'function') window.initializeTagDisplay();
                if (window.AOS && typeof window.AOS.refresh === 'function') window.AOS.refresh();
              }
              // Rebind wishlist handlers for dynamically injected wishlist buttons
              try { if (typeof window.rebindWishlistButtons === 'function') window.rebindWishlistButtons(); } catch(e) { /* ignore */ }
            } catch (e) {
              console.warn('Error re-initializing theme scripts after tab load', e);
            }
            content.dataset.loaded = 'true';
            delete content.dataset.loading;
            // Let per-card binders that only ran at DOMContentLoaded (e.g. the
            // CleverTap add-to-cart tracker) pick up the injected cards.
            document.dispatchEvent(new CustomEvent('wbn:grid:injected', {detail: {container: content}}));
            if (onDone) onDone();
          }).catch(err => {
            delete content.dataset.loading;
            // A transient failure here (network blip, or the fetch getting
            // starved by third-party script congestion around load) would
            // otherwise leave this tab permanently blank for the rest of the
            // page view, since the first tab has no click to retry on.
            if (attempt < 2) {
              setTimeout(() => loadTab(content, onDone, attempt + 1), 1000 * (attempt + 1));
            } else {
              console.error('Failed loading tab products', err);
            }
          });
    }

    // Prefetch the first tab immediately rather than waiting for the user to
    // scroll near it: an IntersectionObserver-gated fetch only starts once
    // the section is within its rootMargin, and on a fast scroll (or a
    // reload that restores scroll position past it) the network round trip
    // can still be visibly in flight when the tab reaches the viewport,
    // leaving the reserved placeholder blank. fetch() itself doesn't block
    // rendering, so there's no first-paint cost to starting it as soon as
    // possible; only the eventual DOM injection is deferred (until the
    // response lands), which is what the perf work here actually cared about.
    // A requestIdleCallback/timeout gate was tried here first, but on this
    // page's third-party script load (Cooee/Bik/CleverTap/GTM/etc. all firing
    // around DOMContentLoaded) the main thread can stay busy long enough that
    // idle never arrives before the timeout, adding up to 2s of avoidable
    // delay for no benefit.
    const firstTab = tabContents[0];
    if (firstTab && firstTab.dataset.loaded === 'false') {
        loadTab(firstTab);
    }

    // Click function
    tabsNav.forEach(tab => {
        tab.addEventListener('click', function(e) {
            e.preventDefault();
            // Preserve tabs container height to avoid layout collapse during lazy load
            if (tabsContainer) {
              const currentHeight = tabsContainer.offsetHeight;
              tabsContainer.style.minHeight = (currentHeight || 0) + 'px';
            }

            tabsNav.forEach(t => t.classList.remove('active'));
            this.classList.add('active');
            tabContents.forEach(content => content.style.display = 'none');

            const activeTab = this.querySelector('a').getAttribute('href');
            const activeContent = document.querySelector(activeTab);
            activeContent.style.display = 'flex';
            function settleHeight() {
                // adjust container height to new content then clear the fixed minHeight
                setTimeout(() => {
                  if (tabsContainer) {
                    const newHeight = activeContent.offsetHeight || 0;
                    tabsContainer.style.minHeight = newHeight + 'px';
                    setTimeout(() => { tabsContainer.style.minHeight = ''; }, 300);
                  }
                }, 50);
            }
            // Lazy-load content if not yet loaded
            if (activeContent && activeContent.dataset.loaded === 'false') {
                loadTab(activeContent, settleHeight);
            }
            else {
                settleHeight();
            }
        });
    });
});
